<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2023-02-28 13:30:21
 * @FilePath: \raacfold\src\components\structure\ProteinStructureView.vue
-->
<template>
    <div class="baimo-scrollbar no-selected">
        <div
            style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8"
        >
            <div class="baimo-toolbar">
                <div
                    style="height: 30px; color: #2F363D; background: #F6F8FA; padding: 6px 10px 0px 10px;white-space:nowrap;overflow:hidden;"
                >
                    <span style>Structure Viewer</span>
                    <i @click="help" style="float: right;">
                        <span class="bm-toolbar-btn">Help</span>
                    </i>
                    <i @click="download_structure" style="float: right;">
                        <span class="bm-toolbar-btn">Download</span>
                    </i>
                    <!-- <i @click="refresh" style="float: right;">
                        <span class="bm-toolbar-btn">Reset</span>
                    </i>-->
                    <el-dropdown
                        class="download-dropdown"
                        style="float: right;font-size: 14px;padding: 0px 5px 0 0px"
                        @command="mode_switch"
                    >
                        <span
                            class="el-dropdown-link"
                            :style="{float: 'right',fontSize: '14px', color: '#1E90FF', cursor: 'pointer'}"
                        >
                            <span class="bm-toolbar-btn">{{current_mode}}</span>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="Raac">Raac Mode</el-dropdown-item>
                            <el-dropdown-item
                                v-if="source_db === 'AlphaFold'"
                                command="Confidence"
                            >Confidence Mode</el-dropdown-item>
                            <el-dropdown-item command="Natural">Natural Mode</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div id="legend"></div>
        <div
            v-loading="loading"
            id="structure_align_cotainer"
            :style="{height: height, width: width, left: '0px', top: '0px', background: 'white', float:'right'}"
        ></div>
    </div>
</template>

<script>
import {
    Stage,
    ColormakerRegistry,
    // KeyActions
    // KeyControls
} from "ngl";
import * as d3 from "d3";

export default {
    name: "StructureView",
    data() {
        return {
            mainHeight: window.innerHeight - 90 + "px",
            winHeight: window.innerHeight - 50 - 595 + "px",
            winWidth: window.innerWidth - 360 - 360 + "px",
            legend_x: 340,
            current_stage: "",
            current_NGL: "",
            src: "",
            timer: "",
            timer2: "",
            loading: false,
            seletedRepr: "",
            seletedReprRaw: "",
            mainRepr: "",
            raac_color8: {},
            protein_pdb: "",
            aa_map: {
                G: "Gly",
                A: "Ala",
                S: "Ser",
                P: "Pro",
                V: "Val",
                T: "Thr",
                C: "Cys",
                L: "Leu",
                I: "Ile",
                N: "Asn",
                D: "Asp",
                Q: "Gln",
                K: "Lys",
                E: "Glu",
                M: "Met",
                H: "His",
                F: "Phe",
                R: "Arg",
                Y: "Tyr",
                W: "Trp",
            },
            structure_global_setting: {},
            structure_selection_setting: {},
            global_surface_setting: {},
            selected_surface_setting: {},
            seleted_setting: {},
            surfaceRepr: null,
            pdb_url: "",
            accession: "",
            pdb_id: "",
            raac_color: "",
            raac_scheme: "",
            is_init: true,
            current_mode: "Raac Mode",
            structure_layer: {},
            natural_seq: "",
            source_db: "",
            global_structure_representation: "Cartoon",
        };
    },
    mounted() {
        let stage = new Stage("structure_align_cotainer", {
            backgroundColor: "white",
        });
        this.stage = stage;

        // console.log("this.stage", this.stage)

        window.addEventListener(
            "resize",
            function () {
                stage.handleResize();
            },
            false
        );
        this.init_legent("raac");
        this.selected_surface_setting =
            this.$store.state.selected_surface_setting;
        this.global_surface_setting = this.$store.state.global_surface_setting;
    },
    watch: {
        protein_pdb() {
            // console.log(val);
        },
        "$store.state.selected_range"(val) {
            val;
            // this.selectedRange = val;
            // console.log("this.selectedRange", this.selectedRange)
            // if (!this.is_init) this.render_update("surface");
        },
        "$store.state.raac_color"(val) {
            // console.log("$store.state.raac_color", val)
            this.raac_color = val;
            this.update_legend();
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.raac_scheme"(val) {
            // console.log("$store.state.raac_scheme", val)
            this.raac_scheme = val;
            // this.update_legend();
            this.structure_layer = {
                main: {},
                selected: {},
            };
        },
        "$store.state.raac_shape"() {
            this.structure_layer = {
                main: {},
                selected: {},
            };
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.raac_visible"() {
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.structure_global_setting"(data) {
            // console.log("this.$store.state.structure_global_settingdata", data)
            this.structure_global_setting = data;
            this.global_structure_representation = data["representation"];
            if (!this.is_init) this.render_update("surface");
            let canvas = document.querySelector("canvas");
            let global_background = this.structure_global_setting["background"];

            canvas.style["background-color"] = global_background;
            if (canvas !== null) {
                // console.log("global_background", global_background);
            }
        },
        "$store.state.structure_selection_setting"(val) {
            this.structure_selection_setting = val;
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.global_surface_setting"(val) {
            // console.log("$store.state.global_surface_setting", val)
            this.global_surface_setting = val;
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.selected_surface_setting"(val) {
            // console.log("$store.state.selected_surface_setting", val)
            this.selected_surface_setting = val;
            if (!this.is_init) this.render_update("surface");
        },
        "$store.state.structure_resize"() {
            this.resize();
        },
        "$store.state.current_protein"(data, olddata) {
            this.source_db = data["source_db"];
            // console.log("source_db", this.source_db);
            // console.log("this.accession !== data[accession]", this.accession, data["accession"]);
            this.is_init = true;
            if (this.source_db === "AlphaFold") {
                if (
                    this.accession !== data["accession"] ||
                    olddata["source_db"] !== data["source_db"]
                ) {
                    // console.log("this.$store.state.current_protein ==>", data);
                    this.pdb_url = data["pdb_url"];
                    this.accession = data["accession"];
                    this.natural_seq = data["natural_seq"];
                    // 重置结构渲染
                    let sequence_menu = this.$store.state.sequence_menu;
                    this.$store.commit("sequenceMenuMutation", {
                        color: [""],
                        focus: false,
                        leftWidth: sequence_menu["leftWidth"],
                        multi: false,
                        representation: [""],
                    });
                    this.init();
                }
            } else {
                if (this.pdb_id !== data["pdb_id"]) {
                    // console.log("this.$store.state.current_protein", data);
                    this.pdb_url = data["pdb_url"];
                    this.accession = data["accession"];
                    this.natural_seq = data["natural_seq"];
                    // 重置结构渲染
                    let sequence_menu = this.$store.state.sequence_menu;
                    this.$store.commit("sequenceMenuMutation", {
                        color: [""],
                        focus: false,
                        leftWidth: sequence_menu["leftWidth"],
                        multi: false,
                        representation: [""],
                    });
                    this.init();
                }
            }
        },
        "$store.state.sequence_menu"(val) {
            this.seleted_setting = val;
            // console.log("this.seleted_setting", this.seleted_setting)
            if (!this.is_init) this.render_update("surface");
            // this.init();
        },
    },
    props: {
        height: String,
        width: String,
    },
    methods: {
        init_legent(mode) {
            // console.log("init_legent", mode);
            if (this.legend !== "" && this.legend !== undefined)
                this.legend.html("");
            switch (mode) {
                case "raac":
                    this.init_raac_legend();
                    break;
                case "conservative":
                    this.init_conservative_legend();
                    break;
                case "confidence":
                    this.init_confidence_legend();
                    break;
                case "natural":
                    this.init_natural_legend();
                    break;
            }
        },
        init_conservative_legend() {
            let style = `position:absolute;left:${
                this.legend_x
            }px;top:${85}px;font-family: "Source Sans Pro"; font-size: 16px; z-index: 9; border-radius: 5px; color: rgb(102, 102, 102); padding: 5px 10px;`;

            this.legend = d3
                .select("#legend")
                .append("div")
                .attr("id", "legend")
                .attr("style", style)
                .attr("opacity", 1)
                .append("rect")
                .attr("id", "legend");
            this.legend.html(
                '<p style="color: #000000; font-size: 12px;" class="stroke">Information score</p> <svg  transform="scale(0.8, 0.8) translate(-50, -12)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="312" height="45" viewBox="0 0 309 45">  <defs>    <linearGradient id="linear-gradient" x1="10.125" y1="14.656" x2="295.125" y2="14.656" gradientUnits="userSpaceOnUse">      <stop offset="0" stop-color="#fce81e"/>      <stop offset="0.557" stop-color="#27ae81"/>      <stop offset="1" stop-color="#430759"/>    </linearGradient>  </defs>  <path id="矩形_1" fill=url(#linear-gradient) data-name="矩形 1" class="cls-1" d="M10.138-.341h285v30h-285v-30Z"/>  <text id="_0.00"  style="font-size: 12px;" data-name="0.00" class="cls-2 stroke" x="0.019" y="44">0.00</text>  <text id="_4.32" style="font-size: 12px;" data-name="4.32" class="cls-2 stroke" x="285.019" y="44">4.32</text></svg>'
            );
        },
        init_confidence_legend() {
            let style = `position:absolute;left:${
                this.legend_x
            }px;top:${85}px;font-family: "Source Sans Pro"; font-size: 16px; z-index: 9; border-radius: 5px; color: rgb(102, 102, 102); padding: 5px 10px;`;

            this.legend = d3
                .select("#legend")
                .append("div")
                .attr("id", "legend")
                .attr("style", style)
                .attr("opacity", 1)
                .append("rect")
                .attr("id", "legend");
            this.legend.html(
                '<p style="color: #000000; font-size: 12px;" class="stroke">Confindence score</p> <svg  transform="scale(0.8, 0.8) translate(-50, -12)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="309" height="45" viewBox="0 0 309 45">  <defs>    <linearGradient id="linear-gradient" x1="10.094" y1="14.656" x2="295.094" y2="14.656" gradientUnits="userSpaceOnUse">      <stop offset="0" stop-color="#eff425"/>      <stop offset="0.455" stop-color="#e4685d"/>      <stop offset="0.722" stop-color="#b9318a"/>      <stop offset="1" stop-color="#2c0494"/>    </linearGradient>  </defs>  <rect id="矩形_1" fill=url(#linear-gradient) data-name="矩形 1" class="cls-1" x="10.094" y="-0.344" width="285" height="30"/>  <text id="_0" style="font-size: 12px;" data-name="0" class="cls-2 stroke" x="6.963" y="44">0</text>  <text id="_50" style="font-size: 12px;" data-name="50" class="cls-2 stroke" x="145.963" y="44">50</text>  <text id="_70" style="font-size: 12px;" data-name="70" class="cls-2 stroke" x="195.963" y="44">70</text>  <text id="_90_" style="font-size: 12px;" data-name="90 " class="cls-2 stroke" x="252.963" y="44">90</text>  <text id="_100" style="font-size: 12px;" data-name="100" class="cls-2 stroke" x="284.963" y="44">100</text></svg>'
            );
        },
        init_raac_legend() {
            this.raac_color = this.$store.state.raac_color;
            this.raac_scheme = this.$store.state.raac_scheme;
            // console.log("this.raac_scheme >> ", this.raac_scheme)
            let style = `background:transparent; position:absolute;left:${
                this.legend_x
            }px;top:${85}px;font-family: "Source Sans Pro"; font-size: 16px; z-index: 9; border-radius: 5px; color: rgb(102, 102, 102); padding: 5px 10px;`;

            this.legend = d3
                .select("#legend")
                .append("div")
                .attr("id", "legend")
                .attr("style", style)
                .attr("opacity", 0)
                .append("rect")
                .attr("id", "legend");
            this.legend
                .append("p")
                .attr("style", "color: #000000; font-size: 12px; margin:0px")
                .attr("class", "stroke")
                .text("Raac scheme");
            this.raac_scheme = this.$store.state.raac_scheme;
            this.raac_scheme.forEach((item, i) => {
                this.legend
                    .append("span")
                    .text(item)
                    .attr("class", "seq")
                    .attr("style", "background: " + this.raac_color[i]);
            });
        },
        init_natural_legend() {
            let colors = {
                A: "#f3a683",
                B: "#8e44ad",
                C: "#cf6a87",
                D: "#e77f67",
                E: "#f5cd79",
                F: "#ea8685",
                G: "#546de5",
                H: "#e15f41",
                I: "#c44569",
                K: "#f8a5c2",
                L: "#786fa6",
                M: "#63cdda",
                N: "#778beb",
                P: "#596275",
                Q: "#f19066",
                R: "#f7d794",
                S: "#574b90",
                T: "#f78fb3",
                U: "#34495e",
                V: "#303952",
                W: "#3dc1d3",
                Y: "#e66767",
                X: "#bdc3c7",
                a: "#f3a683",
                b: "#8e44ad",
                c: "#cf6a87",
                d: "#e77f67",
                e: "#f5cd79",
                f: "#ea8685",
                g: "#546de5",
                h: "#e15f41",
                i: "#c44569",
                k: "#f8a5c2",
                l: "#786fa6",
                m: "#63cdda",
                n: "#778beb",
                p: "#596275",
                q: "#f19066",
                r: "#f7d794",
                s: "#574b90",
                t: "#f78fb3",
                u: "#34495e",
                v: "#303952",
                w: "#3dc1d3",
                y: "#e66767",
                x: "#bdc3c7",
                " ": "transparent",
                "-": "transparent",
                "*": "#353b48",
            };
            let raac_scheme = [
                "G",
                "A",
                "S",
                "P",
                "V",
                "T",
                "C",
                "L",
                "I",
                "N",
                "D",
                "Q",
                "K",
                "E",
                "M",
                "H",
                "F",
                "R",
                "Y",
                "W",
            ];
            let style = `position:absolute;left:${
                this.legend_x
            }px;top:${85}px;font-family: "Source Sans Pro"; font-size: 16px; z-index: 9; border-radius: 5px; color: rgb(102, 102, 102); padding: 5px 10px;`;

            this.legend = d3
                .select("#legend")
                .append("div")
                .attr("id", "legend")
                .attr("style", style)
                .attr("opacity", 1)
                .append("rect")
                .attr("id", "legend");
            this.legend
                .append("p")
                .attr("style", "color: #000000; font-size: 12px; margin:0px")
                .attr("class", "stroke")
                .text("Raac scheme");
            raac_scheme.forEach((item) => {
                this.legend
                    .append("span")
                    .text(item)
                    .attr("class", "seq")
                    .attr("style", "background: " + colors[item]);
            });
        },
        update_legend() {
            this.legend.selectAll("*").remove();
            let style = `background:transparent; position:absolute;left:${
                this.legend_x
            }px;top:${85}px;font-family: "Source Sans Pro"; font-size: 16px; z-index: 9; border-radius: 5px; color: rgb(102, 102, 102); padding: 5px 10px;`;

            this.legend = d3
                .select("#legend")
                .append("div")
                .attr("id", "legend")
                .attr("style", style)
                .attr("opacity", 1)
                .append("rect")
                .attr("id", "legend");
            this.legend
                .append("p")
                .attr("style", "color: #000000; font-size: 12px; margin:0px")
                .attr("class", "stroke")
                .text("Raac scheme");
            this.raac_scheme = this.$store.state.raac_scheme;
            this.raac_scheme.forEach((item, i) => {
                this.legend
                    .append("span")
                    .text(item)
                    .attr("class", "seq")
                    .attr("style", "background: " + this.raac_color[i]);
            });
        },
        mode_switch(command) {
            this.current_mode = command + " Mode";
            if (!this.is_init) this.render_update("surface");
            // console.log("this.current_mode", this.current_mode)
            switch (command) {
                case "Raac":
                    this.init_legent("raac");
                    break;
                case "Confidence":
                    this.init_legent("confidence");
                    break;
                case "Conservative":
                    this.init_legent("conservative");
                    break;
                case "Natural":
                    this.init_legent("natural");
                    break;
            }
        },
        init() {
            // console.log("this.$store.state.sequence_menu", this.$store.state.sequence_menu)
            // console.log("this.$store.state.structure_global_setting", this.$store.state.structure_global_setting)
            this.global_surface_setting =
                this.$store.state.global_surface_setting;
            this.structure_global_setting =
                this.$store.state.structure_global_setting;
            this.seleted_setting = this.$store.state.sequence_menu;
            this.loading = true;
            let vue_obj = this;
            this.stage.removeAllComponents();
            this.structure_layer = {
                main: {},
                selected: {},
            };

            // console.log("init >>>>>>>>>>>>>", this.stage.keyBehavior)
            // console.log("vue_obj.stage.keyControls", this.stage.keyControls)
            let pdb_data = "";
            this.pdb_url = this.$store.state.current_protein["pdb_url"];
            if (this.source_db === "AlphaFold") {
                pdb_data = `http://${window.location.host}/${this.pdb_url}`;
            } else {
                pdb_data = this.pdb_url;
            }

            this.stage.loadFile(pdb_data).then(function (component) {
                // console.log("this.stage.loadFile(this.pdb_url)")
                vue_obj.component = component;
                vue_obj.seletedReprRaw = component;
                vue_obj.render_update("init");
                vue_obj.tooltip();
                component.autoView();
                vue_obj.loading = false;
                // vue_obj.stage.keyControls.add("r", KeyActions.autoView);
            });
        },
        refresh() {
            this.loading = true;
            // 重置选取
            let sequence_menu = this.$store.state.sequence_menu;
            delete sequence_menu["range"];
            sequence_menu["leftWidth"] = "";
            sequence_menu["representation"][0] = "";
            sequence_menu["focus"] = false;
            sequence_menu["multi"] = false;
            // delete sequence_menu["range"];
            this.$store.commit("sequenceMenuMutation", {
                color: [""],
                focus: false,
                multi: false,
                leftWidth: sequence_menu["leftWidth"],
                representation: [""],
            });
            // 重置全局
            // let global_setting = this.$store.state.structure_global_setting;
            // global_setting['representation'] = "Cartoon",
            // global_setting['color'] = "",
            // global_setting['background'] = "white",
            // global_setting['animation'] = false,
            // global_setting['focus'] = false,
            // this.$store.commit('StructureGlobalSettingMutation', global_setting);
            // console.log("this.$store.state.structure_global_setting", this.$store.state.structure_global_setting)

            let current_protein = this.$store.state.current_protein;
            this.pdb_url = current_protein["pdb_url"];
            this.accession = current_protein["accession"];
            this.natural_seq = current_protein["natural_seq"];
            this.render_update();
            this.loading = false;
            // window.location.reload();
        },
        resize() {
            this.stage.handleResize();
        },
        download_structure() {
            let file_name = this.accession;
            var canvas = document.querySelector("canvas");
            var a = document.createElement("a");
            a.href = canvas.toDataURL("image/png");
            a.download = file_name;
            a.click();
        },
        selected_render() {
            // console.log("selected_render", this.seleted_setting);
            if (
                this.seleted_setting["range"] !== null &&
                this.seleted_setting["range"] !== undefined
            ) {
                let start = this.seleted_setting["range"]["start"];
                let end = this.seleted_setting["range"]["end"];
                let deletes = [];
                let subselected_color = this.seleted_setting["color"];
                let is_focus = this.seleted_setting["focus"];
                let subselected_repr = this.seleted_setting["representation"];
                let selected_repr =
                    this.structure_selection_setting["representation"];
                let selected_color = this.structure_selection_setting["color"];
                let selected_effect =
                    this.structure_selection_setting["effect"];
                // let selected_focus = this.structure_selection_setting["focus"];
                // console.log(
                //     "this.structure_selection_setting",
                //     this.structure_selection_setting
                // );
                let min_start = 10000000000;
                let max_end = 0;
                let seq_len = this.natural_seq.length;
                // console.log("start", start);
                // console.log("end", end);
                let has_delete = Object.prototype.hasOwnProperty.call(
                    this.seleted_setting,
                    "delete"
                );
                if (has_delete) {
                    deletes = this.seleted_setting["delete"];
                }

                let finish_seq = [];
                for (let j = 1; j <= seq_len; j++) {
                    finish_seq.push(j);
                }

                for (let i = 0; i < start.length; i++) {
                    let cur_start = start[i];
                    let cur_end = end[i];
                    let cur_delete = deletes[i];
                    // console.log("cur_delete", cur_delete, finish_seq[i], cur_start, cur_end)
                    if (cur_delete) {
                        for (let j = 0; j < seq_len; j++) {
                            if (
                                finish_seq[j] >= cur_start &&
                                finish_seq[j] <= cur_end
                            ) {
                                finish_seq[j] = -1;
                            }
                        }
                    }
                }

                // console.log("finish_seq", finish_seq);

                let delete_focus = false;

                for (let i = 0; i < start.length; i++) {
                    if (deletes[i]) {
                        delete_focus = true;
                    }
                }
                if (delete_focus) {
                    for (let i = 0; i < finish_seq.length; i++) {
                        let val = finish_seq[i];
                        if (val != -1) {
                            if (val < min_start) min_start = val;
                            if (val > max_end) max_end = val;
                        }
                    }
                } else {
                    // console.log("delete_focus", delete_focus)
                    for (let i = 0; i < start.length; i++) {
                        if (parseInt(start[i]) < min_start)
                            min_start = start[i];
                        if (parseInt(end[i]) > max_end) max_end = end[i];
                        // console.log("start-end", start[i], min_start, end[i], max_end)
                    }
                }

                // 选取模型，颜色渲染
                // let representation_map = []
                let representation = "";
                let pdb_start = 0;
                let pdb_chain = this.$store.state.current_protein["pdb_chain"];
                // if(this.source_db === "PDB") pdb_start = this.$store.state.current_protein["pdb_start"];
                for (let i = 0; i < start.length; i++) {
                    let cur_start = start[i];
                    let cur_end = end[i];
                    let cur_color = subselected_color[i];
                    let cur_repr = subselected_repr[i];
                    let setting = {
                        sele: `${cur_start - pdb_start}-${cur_end - pdb_start}`,
                    };

                    // 全局选区设置
                    if (selected_color === "" || selected_color === null) {
                        delete setting["color"];
                    } else {
                        setting["color"] = selected_color;
                    }
                    if (this.seleted_setting["shape"] === "point") {
                        setting = {
                            sele: `${cur_start - pdb_start}, ${
                                cur_end - pdb_start
                            }`,
                        };
                    }
                    // representation_map[i]['repr'] = selected_repr;
                    // representation_map[i]['setting'] = setting;
                    // console.log("cur_color>>>", cur_color, setting)
                    // 子选区设置
                    if (cur_color === "raac") {
                        setting["color"] = this.get_seleted_color("raac");
                    } else if (cur_color === "confidence") {
                        setting["color"] = this.get_seleted_color("confidence");
                    } else if (cur_color === "conservation") {
                        setting["color"] =
                            this.get_seleted_color("conservation");
                    } else if (cur_color === "natural") {
                        setting["color"] = this.get_seleted_color("natural");
                    } else if (cur_color === "") {
                        // console.log("else if (cur_color ===")
                        delete setting["color"];
                    } else {
                        // console.log("else")
                        setting["color"] = cur_color;
                    }

                    if (cur_repr !== "") representation = cur_repr;
                    else representation = selected_repr;
                    // console.log("representation", representation, cur_repr, selected_repr)
                    // console.log("setting>>>", setting)

                    //删除区域
                    if (
                        this.seleted_setting["delete"][i] ||
                        representation === "transparent"
                    ) {
                        representation = "base";
                    }

                    setting = this.get_surface_seleted_setting(
                        representation,
                        setting["sele"] +
                            " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                        setting["color"]
                    );
                    // console.log("setting>>>", setting)
                    if (
                        selected_effect === "Double" ||
                        selected_effect === "Current selected representation"
                    ) {
                        this.seletedReprRaw.addRepresentation(
                            representation,
                            setting
                        );
                        setting["visible"] = false;
                    }
                }

                // console.log("min_start, max_end", min_start, max_end, delete_focus);

                // 焦点
                if (is_focus || delete_focus) {
                    if (this.source_db === "AlphaFold")
                        this.seletedReprRaw.autoView(
                            `${min_start}-${max_end}` +
                                " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                            1000
                        );
                    else
                        this.seletedReprRaw.autoView(
                            `:${pdb_chain}/0 and ${min_start}-${max_end}` +
                                " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                            1000
                        );
                } else {
                    if (this.source_db === "AlphaFold")
                        this.seletedReprRaw.autoView(
                            `0-${seq_len}` +
                                " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                            1000
                        );
                    else
                        this.seletedReprRaw.autoView(
                            `:${pdb_chain}/0 and 0-${seq_len}` +
                                " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                            1000
                        );
                }
            }
        },
        render_update(composition) {
            // let color = this.$store.state.raac_color;
            // 提取氨基酸约化模型，颜色，可见设置 ========================================
            let shape = this.$store.state.raac_shape;
            let visible = this.$store.state.raac_visible;
            let scheme = this.$store.state.raac_scheme;
            let pdb_chain = this.$store.state.current_protein["pdb_chain"];
            let pdb_start = 0;
            let color_scheme = this.get_scheme();

            // if(this.source_db === "PDB") pdb_start = this.$store.state.current_protein['pdb_start'];
            this.color_scheme = color_scheme;
            // console.log("scheme", scheme)
            // console.log("shape", shape)

            let sele = {};
            for (let i = 0; i < scheme.length; i++) {
                let cur_scheme = scheme[i];
                let cur_shape = shape[i];
                let cur_visible = visible[i];

                if (typeof sele[cur_shape] != "object") {
                    sele[cur_shape] = [];
                }
                if (cur_visible) {
                    for (let j = 0; j < cur_scheme.length; j++) {
                        let scheme_aa = cur_scheme[j];
                        sele[cur_shape].push2(this.aa_map[scheme_aa]);
                    }
                }
            }

            //删除区域
            let delete_region_arr = [];
            // console.log(">>>this.seleted_setting", this.seleted_setting)
            // console.log(">>>this.seleted_setting['delete']", this.seleted_setting['delete'])
            if (this.seleted_setting["delete"] !== undefined) {
                for (
                    let i = 0;
                    i < this.seleted_setting["delete"].length;
                    i++
                ) {
                    if (this.seleted_setting["delete"][i]) {
                        let start = this.seleted_setting["range"]["start"];
                        let end = this.seleted_setting["range"]["end"];
                        // console.log("start...", start)
                        delete_region_arr.push(
                            `not ${start[i] - pdb_start}-${end[i] - pdb_start}`
                        );
                    }
                }
            }

            let delete_region = "";
            if (delete_region_arr.length) {
                delete_region = delete_region_arr.join(" and ");
            }
            // console.log(">>>delete_region_arr", delete_region_arr)
            // console.log(">>>this.seletedReprRaw", this.seletedReprRaw)
            this.seletedReprRaw.removeAllRepresentations();
            // 渲染模型，颜色
            // let layer_index = 0;
            for (let cur_shape in sele) {
                // console.log("sele[cur_shape]", sele[cur_shape])
                // let cur_sele = ":" + pdb_chain + " and " + delete_region;
                let cur_sele = delete_region;
                // console.log("delete_region", delete_region)
                // console.log("chain", pdb_chain)

                let setting = this.get_surface_setting(
                    this.global_structure_representation,
                    cur_sele +
                        " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                    color_scheme
                );
                // console.log(">>>>>>>>", this.global_structure_representation, setting)
                this.mainRepr = this.seletedReprRaw.addRepresentation(
                    this.global_structure_representation,
                    setting
                );
            }

            // 蛋白表面渲染
            composition;

            this.selected_render();
            this.set_animation();
            // this.set_focus(composition);
            if (this.is_init) {
                let range = "";
                if (this.source_db === "PDB")
                    range = `:${pdb_chain}/0 and 0-10000000`;
                else range = "0-10000000";
                // console.log("cur_sele ---> range", range)
                this.seletedReprRaw.autoView(
                    range +
                        " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                    1000
                );
            }

            this.is_init = false;
        },
        get_surface_setting(repr, cur_sele, color_scheme) {
            let setting = {};
            // console.log("get_surface_setting", repr, cur_sele, color_scheme)
            let pdb_chain = this.$store.state.current_protein["pdb_chain"];
            if (this.source_db === "PDB")
                cur_sele = `:${pdb_chain}/0 and ${cur_sele}`;
            // console.log("cur_sele ---> get_surface_setting", cur_sele)
            if (repr === "Surface") {
                // console.log("get_surface_setting", this.global_surface_setting)
                setting = {
                    sele:
                        cur_sele +
                        " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                    surfaceType: this.global_surface_setting["surface_type"], // 'vws', 'sas', 'ms' and 'sas', 'av' https://github.com/nglviewer/ngl/issues/655
                    opacity: this.global_surface_setting["surface_opacity"], // 0-1,0.01
                    contour: this.global_surface_setting["surface_contour"],
                    side: this.global_surface_setting[
                        "surface_side"
                    ].toLowerCase(),
                    smooth: this.global_surface_setting["surface_smooth"],
                    roughness: this.global_surface_setting["surface_roughness"], //0-1,0.01
                    metalness: this.global_surface_setting["surface_metalness"], //0-1,0.01
                    probeRadius:
                        this.global_surface_setting["surface_probe_radius"], // 0- 20,1
                    scaleFactor:
                        this.global_surface_setting["surface_scale_factor"], // 0-5,1
                    flatShaded:
                        this.global_surface_setting["surface_flat_shaded"],
                    colorScheme: color_scheme,
                };
                // let surface_color = this.global_surface_setting["surface_color"];
                // if (surface_color === "" || surface_color === null) {
                //     delete setting["color"];
                // } else {
                //     setting["color"] = surface_color;
                // }
                return setting;
            } else {
                setting = {
                    sele: cur_sele,
                    colorScheme: color_scheme,
                };
                return setting;
            }
        },
        get_surface_seleted_setting(repr, cur_sele, color_scheme) {
            let setting = {};
            let selected_surface_setting =
                this.$store.state.selected_surface_setting;
            let current_protein = this.$store.state.current_protein;
            let pdb_chain = current_protein["pdb_chain"];
            if (this.source_db === "AlphaFold") {
                cur_sele = `${cur_sele}`;
            } else {
                cur_sele = `:${pdb_chain}/0 and ${cur_sele}`;
            }
            // console.log("cur_sele ---> get_surface_seleted_setting", cur_sele)
            // console.log("get_surface_seleted_setting", repr, cur_sele, color_scheme)
            if (repr === "Surface" || repr === "surface") {
                // console.log("get_surface_seleted_setting", selected_surface_setting)
                setting = {
                    sele:
                        cur_sele +
                        " and [GLY,ALA,SER,PRO,VAL,THR,CYS,LEU,ILE,ASN,ASP,GLN,LYS,GLU,MET,HIS,PHE,ARG,TYR,TRP]",
                    surfaceType: selected_surface_setting["surface_type"], // 'vws', 'sas', 'ms' and 'sas', 'av' https://github.com/nglviewer/ngl/issues/655
                    opacity: selected_surface_setting["surface_opacity"], // 0-1,0.01
                    contour: selected_surface_setting["surface_contour"],
                    side: selected_surface_setting[
                        "surface_side"
                    ].toLowerCase(),
                    smooth: selected_surface_setting["surface_smooth"],
                    roughness: selected_surface_setting["surface_roughness"], //0-1,0.01
                    metalness: selected_surface_setting["surface_metalness"], //0-1,0.01
                    probeRadius:
                        selected_surface_setting["surface_probe_radius"], // 0- 20,1
                    scaleFactor:
                        selected_surface_setting["surface_scale_factor"], // 0-5,1
                    flatShaded: selected_surface_setting["surface_flat_shaded"],
                };

                if (color_scheme !== "" && color_scheme !== undefined) {
                    if (color_scheme[0] === "#") {
                        setting["color"] = color_scheme;
                    } else {
                        setting["colorScheme"] = color_scheme;
                    }
                }
                // let surface_color = this.global_surface_setting["surface_color"];
                // if (surface_color === "" || surface_color === null) {
                //     delete setting["color"];
                // } else {
                //     setting["color"] = surface_color;
                // }
                return setting;
            } else {
                setting = {
                    sele: cur_sele,
                };
                if (color_scheme !== "" && color_scheme !== undefined) {
                    if (color_scheme[0] === "#") {
                        setting["color"] = color_scheme;
                    } else {
                        setting["colorScheme"] = color_scheme;
                    }
                }
                return setting;
            }
        },
        set_animation() {
            // 动画设置
            let animation = this.structure_global_setting["animation"];
            this.stage.setSpin(animation);
        },
        set_focus(composition) {
            // 焦点设置
            let focus = this.structure_global_setting["focus"];
            if (composition === "refresh" || composition === "init" || focus) {
                this.seletedReprRaw.autoView(1000);
            }
        },
        get_scheme() {
            let vue_obj = this;
            // console.log("this.$store.state.structure_global_setting", this.$store.state.structure_global_setting)
            switch (this.current_mode) {
                case "Raac Mode":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            let color = vue_obj.get_raac_color()[atom.resname];
                            if (color !== undefined) return color;
                            else return parseInt("0xFFFFFFFF", 16);
                        };
                    });
                case "Confidence Mode":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_confindece_color()[
                                atom.resno - 1
                            ];
                        };
                    });
                case "Conservative Mode":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            if (
                                Object.prototype.hasOwnProperty.call(
                                    vue_obj.get_conservative_color(),
                                    atom.resno - 1
                                )
                            ) {
                                return vue_obj.get_conservative_color()[
                                    atom.resno - 1
                                ];
                            } else {
                                return "0xFFFFFF";
                            }
                        };
                    });
                case "Natural Mode":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_natural_color()[atom.resname];
                        };
                    });
                default:
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_raac_color()[atom.resname];
                        };
                    });
            }

            // try {

            // let schemeId = ColormakerRegistry.addScheme(function() {
            //     this.atomColor = function(atom) {
            //         console.log(atom.resno)
            //         return raac_scheme[atom.resname];
            //     };
            // });

            // return schemeId;
            // } catch (e) {
            //     e
            // }
        },
        get_seleted_color(val) {
            let vue_obj = this;
            switch (val) {
                case "raac":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            let color = vue_obj.get_raac_color()[atom.resname];
                            if (color !== undefined) return color;
                            else return parseInt("0xFFFFFFFF", 16);
                        };
                    });
                case "natural":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_natural_color()[atom.resname];
                        };
                    });
                case "confidence":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_confindece_color()[
                                atom.resno - 1
                            ];
                        };
                    });
                case "conservation":
                    return ColormakerRegistry.addScheme(function () {
                        this.atomColor = function (atom) {
                            return vue_obj.get_conservative_color()[
                                atom.resno - 1
                            ];
                        };
                    });
            }
        },
        get_raac_color() {
            let aa_map = {
                G: "GLY",
                A: "ALA",
                S: "SER",
                P: "PRO",
                V: "VAL",
                T: "THR",
                C: "CYS",
                L: "LEU",
                I: "ILE",
                N: "ASN",
                D: "ASP",
                Q: "GLN",
                K: "LYS",
                E: "GLU",
                M: "MET",
                H: "HIS",
                F: "PHE",
                R: "ARG",
                Y: "TYR",
                W: "TRP",
            };
            let res = {};
            // let raacs = input.raac.split("-");
            // let colors = input.color.split(",");
            let raacs = this.$store.state.raac_scheme;
            let colors = this.$store.state.raac_color;
            // console.log(raacs,colors);
            for (let i = 0; i < raacs.length; i++) {
                let group = raacs[i];
                let group_color = colors[i].replace("#", "0x");
                for (let j = 0; j < group.length; j++) {
                    let aa_name = aa_map[group[j]];
                    this.raac_color8[aa_name] = colors[i];
                    // console.log(group_color, typeof (group_color.toString(16)))
                    res[aa_name] = parseInt(group_color, 16);
                }
            }
            return res;
        },
        get_natural_color() {
            let aa_map = {
                G: "GLY",
                A: "ALA",
                S: "SER",
                P: "PRO",
                V: "VAL",
                T: "THR",
                C: "CYS",
                L: "LEU",
                I: "ILE",
                N: "ASN",
                D: "ASP",
                Q: "GLN",
                K: "LYS",
                E: "GLU",
                M: "MET",
                H: "HIS",
                F: "PHE",
                R: "ARG",
                Y: "TYR",
                W: "TRP",
            };
            let colors = {
                A: "#f3a683",
                B: "#8e44ad",
                C: "#cf6a87",
                D: "#e77f67",
                E: "#f5cd79",
                F: "#ea8685",
                G: "#546de5",
                H: "#e15f41",
                I: "#c44569",
                K: "#f8a5c2",
                L: "#786fa6",
                M: "#63cdda",
                N: "#778beb",
                P: "#596275",
                Q: "#f19066",
                R: "#f7d794",
                S: "#574b90",
                T: "#f78fb3",
                U: "#34495e",
                V: "#303952",
                W: "#3dc1d3",
                Y: "#e66767",
                X: "#bdc3c7",
                a: "#f3a683",
                b: "#8e44ad",
                c: "#cf6a87",
                d: "#e77f67",
                e: "#f5cd79",
                f: "#ea8685",
                g: "#546de5",
                h: "#e15f41",
                i: "#c44569",
                k: "#f8a5c2",
                l: "#786fa6",
                m: "#63cdda",
                n: "#778beb",
                p: "#596275",
                q: "#f19066",
                r: "#f7d794",
                s: "#574b90",
                t: "#f78fb3",
                u: "#34495e",
                v: "#303952",
                w: "#3dc1d3",
                y: "#e66767",
                x: "#bdc3c7",
                " ": "transparent",
                "-": "transparent",
                "*": "#353b48",
            };
            let res = {};
            let natural = "GASPVTCLINDQKEMHFRYW";
            for (let i = 0; i < natural.length; i++) {
                let aa = natural[i];
                let color = colors[aa].replace("#", "0x");
                let aa_name = aa_map[aa];
                this.raac_color8[aa_name] = colors[i];
                // console.log(group_color, typeof (group_color.toString(16)))
                res[aa_name] = parseInt(color, 16);
            }
            return res;
        },
        get_confindece_color() {
            return this.$store.state.structure_global_setting["confidence"][
                "color"
            ];
        },
        get_conservative_color() {
            return this.$store.state.structure_global_setting["conservative"][
                "color"
            ];
        },
        onClick() {
            this.stage.mouseControls.remove("hoverPick");
            this.stage.signals.clicked.add(function (pickingProxy) {
                // console.log(pickingProxy);
                let atom = pickingProxy.atom || pickingProxy.closestBondAtom;
                let atom_name = atom.qualifiedName();
                let resname = atom.resname;
                // console.log(atom_name, resname);
            });
        },
        help() {},
        tooltip() {
            let tooltip = document.createElement("div");
            Object.assign(tooltip.style, {
                display: "none",
                position: "fixed",
                zIndex: 10,
                pointerEvents: "none",
                backgroundColor: "rgba( 0, 0, 0, 0.6 )",
                color: "lightgrey",
                padding: "8px",
                fontFamily: "sans-serif",
            });
            document.body.appendChild(tooltip);
            let raac_color8 = this.raac_color8;
            this.stage.mouseControls.remove("hoverPick");
            this.stage.signals.hovered.add(function (pickingProxy) {
                if (pickingProxy && (pickingProxy.atom || pickingProxy.bond)) {
                    let atom =
                        pickingProxy.atom || pickingProxy.closestBondAtom;
                    let atom_name = atom.qualifiedName();
                    let resname = atom.resname;
                    let current_color = raac_color8[resname];
                    tooltip.innerHTML = `<i class='iconfont icon-yuan tooltip-circle' style="color:${current_color}"></i>  ${resname}<br/>${atom_name}`;
                    let mp = pickingProxy.mouse.position;
                    tooltip.style.bottom = window.innerHeight - mp.y + 3 + "px";
                    tooltip.style.left = mp.x + 3 + "px";
                    tooltip.style.display = "block";
                    Object.assign(tooltip.style, {
                        position: "absolute",
                        zIndex: 10,
                        pointerEvents: "none",
                        backgroundColor: "white",
                        color: "rgb(102, 102, 102)",
                        padding: "0.5em",
                        fontFamily: "sans-serif",
                        borderRadius: "4px",
                        borderWidth: "1px",
                        boxShadow: "rgb(0 0 0 / 20%) 1px 2px 10px",
                        transition:
                            "opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s",
                    });
                } else {
                    tooltip.style.display = "none";
                }
            });
        },
    },
};

Array.prototype.push2 = function () {
    for (var i = 0; i < arguments.length; i++) {
        var ele = arguments[i];
        if (this.indexOf(ele) == -1) {
            this.push(ele);
        }
    }
};
</script>

<style scoped>
.baimo-scrollbar {
    overflow: hidden;
}

.topright-icon {
    float: right;
    left: 10px;
    top: 10px;
}

.bm-btn {
    cursor: pointer;
}

.bm-toolbar-btn {
    font-size: 12px;
    margin-bottom: 15px;
    padding-bottom: 15px;
    padding-left: 10px;
    font-style: normal;
    cursor: pointer;
    /* box-shadow:0 1px 0 rgba(0,0,0,.2) inset,0 -1px 0 rgba(255,255,255,.2) inset; */
}

.A {
    background: #f3a683;
    padding: 3px;
}

.R {
    background: #f7d794;
    padding: 3px;
}

.N {
    background: #778beb;
    padding: 3px;
}

.D {
    background: #e77f67;
    padding: 3px;
}

.C {
    background: #cf6a87;
    padding: 3px;
}

.Q {
    background: #f19066;
    padding: 3px;
}

.E {
    background: #f5cd79;
    padding: 3px;
}

.G {
    background: #546de5;
    padding: 3px;
}

.H {
    background: #e15f41;
    padding: 3px;
}

.I {
    background: #c44569;
    padding: 3px;
}

.L {
    background: #786fa6;
    padding: 3px;
}

.K {
    background: #f8a5c2;
    padding: 3px;
}

.M {
    background: #63cdda;
    padding: 3px;
}

.F {
    background: #ea8685;
    padding: 3px;
}

.P {
    background: #596275;
    padding: 3px;
}

.S {
    background: #574b90;
    padding: 3px;
}

.T {
    background: #f78fb3;
    padding: 3px;
}

.W {
    background: #3dc1d3;
    padding: 3px;
}

.Y {
    background: #e66767;
    padding: 3px;
}

.V {
    background: #303952;
    padding: 3px;
}

.eq {
    background: #f3a683;
    padding: 3px;
}

.ad {
    background: #f7d794;
    padding: 3px;
}

.re {
    background: #778beb;
    padding: 3px;
}

.eq {
    background: #e77f67;
    padding: 3px;
}

.ad {
    background: #cf6a87;
    padding: 3px;
}

.re {
    background: #f19066;
    padding: 3px;
}

.alpha {
    background: #f5cd79;
    padding: 3px;
}

.beta {
    background: #546de5;
    padding: 3px;
}

.bm-seq {
    width: 22px;
    /*letter-spacing:6px;*/
    font-family: Monaco, Consolas, monospace;
    color: white !important;
    text-shadow: 1px 1px 1px #000;
    font-size: 20px;
    white-space: no-wrap;

    moz-user-select: -moz-none;
    -moz-user-select: none;
    -o-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>